/**
 * CartCouponFormRenderer - Nova Cart Integration
 *
 * Renders the coupon form in the cart page.
 * Uses the existing CartCouponForm from module-flash-sale
 * which internally opens the CouponSelectionScreen.
 */

import React from 'react';
import { CartCouponForm } from '@kidslabs/module-flash-sale';
import styles from './cart-coupon-form-renderer.module.css';

export const CartCouponFormRenderer = () => {
    return <CartCouponForm containerClassName={styles.couponFormContainer} />;
};
